(() => {
  if (window.dbSeasonalCampaignLoaded) return;
  window.dbSeasonalCampaignLoaded = true;
  const placements = [...document.querySelectorAll('[data-db-campaign-active]')];
  const popup = document.querySelector('[data-db-campaign-popup]');
  const emit = (action, element) => document.dispatchEvent(new CustomEvent('db:campaign', { detail: { action, placement: element?.dataset.dbCampaignPlacement || '', campaign: popup?.dataset.dbCampaignKey || '' } }));
  const expire = () => {
    const now = Date.now();
    placements.forEach(element => {
      const end = Date.parse(element.dataset.dbCampaignEnd);
      if (Number.isFinite(end) && now > end) element.hidden = true;
    });
    const landing = document.querySelector('[data-db-campaign-placement="landing"]');
    if (landing?.hidden) document.querySelector('[data-db-campaign-expired]')?.removeAttribute('hidden');
    const homeFeature = document.querySelector('[data-db-campaign-placement="feature"]');
    if (homeFeature?.hidden) document.querySelector('[data-db-campaign-home-fallback]')?.removeAttribute('hidden');
  };
  expire();
  const endTimes = placements.map(e => Date.parse(e.dataset.dbCampaignEnd)).filter(Number.isFinite);
  if (endTimes.length) {
    const remaining = Math.min(...endTimes) - Date.now() + 50;
    if (remaining > 0) window.setTimeout(expire, Math.min(remaining, 2147483647));
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-db-campaign-link], [data-db-campaign-buy]');
    if (link) emit('click', link.closest('[data-db-campaign-placement]'));
  });
  if (!popup || !window.matchMedia('(min-width: 990px)').matches) return;
  const key = `db:campaign:${popup.dataset.dbCampaignKey}`;
  const ends = Date.parse(popup.dataset.dbCampaignEnd);
  const starts = Date.parse(popup.dataset.dbCampaignStart);
  if (!Number.isFinite(ends) || !Number.isFinite(starts) || Date.now() > ends || Date.now() < starts) return;
  let pages = 0;
  let firstSeen = Date.now();
  try {
    if (Number(localStorage.getItem(`${key}:closedUntil`) || 0) > Date.now()) return;
    if (sessionStorage.getItem(`${key}:viewed`) === '1') return;
    const testKey = `${key}:storage`;
    sessionStorage.setItem(testKey, '1');
    sessionStorage.removeItem(testKey);
    pages = Number(sessionStorage.getItem(`${key}:pages`) || 0) + 1;
    firstSeen = Number(sessionStorage.getItem(`${key}:firstSeen`) || Date.now());
    sessionStorage.setItem(`${key}:pages`, String(pages));
    sessionStorage.setItem(`${key}:firstSeen`, String(firstSeen));
  } catch { return; }
  const visible = element => {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0;
  };
  const hasBlockingSurface = () => [...document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog[open], #shopify-pc__banner, .shopify-pc__banner')].some(element => {
    if (element.closest('details[open]')) return true;
    return visible(element);
  });
  const busy = () => {
    const focused = document.activeElement;
    if (focused?.matches('input, select, textarea, [contenteditable="true"]')) return true;
    const box = { left: innerWidth - 382, right: innerWidth - 22, top: innerHeight - 370, bottom: innerHeight - 22 };
    return [...document.querySelectorAll('form[action*="/cart/add"] button[type="submit"]')].filter(visible).some(button => {
      const rect = button.getBoundingClientRect();
      return rect.left < box.right && rect.right > box.left && rect.top < box.bottom && rect.bottom > box.top;
    });
  };
  let interval;
  let shown = false;
  let surfaceObserver;
  const close = () => {
    if (!shown) return;
    popup.hidden = true;
    surfaceObserver?.disconnect();
    const days = Math.max(1, Number(popup.dataset.dbCampaignSnooze) || 7);
    try { localStorage.setItem(`${key}:closedUntil`, String(Date.now() + days * 86400000)); } catch {}
    emit('close', popup);
  };
  const openedAt = Date.now();
  const tryShow = () => {
    if (Date.now() > ends) { popup.hidden = true; clearInterval(interval); return; }
    if (!matchMedia('(min-width: 990px)').matches || document.hidden || hasBlockingSurface() || busy()) return;
    const elapsed = Date.now() - firstSeen;
    const required = Math.max(5, Number(popup.dataset.dbCampaignDelay) || 25) * 1000;
    if (elapsed < required && !(pages >= 2 && Date.now() - openedAt >= 5000)) return;
    try {
      if (sessionStorage.getItem(`${key}:viewed`) === '1') { clearInterval(interval); return; }
      sessionStorage.setItem(`${key}:viewed`, '1');
    } catch { clearInterval(interval); return; }
    popup.hidden = false;
    shown = true;
    clearInterval(interval);
    let scheduled = false;
    surfaceObserver = new MutationObserver(() => {
      if (scheduled || popup.hidden) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        if (hasBlockingSurface()) { popup.hidden = true; surfaceObserver.disconnect(); }
      });
    });
    surfaceObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'style', 'aria-hidden'] });
    emit('view', popup);
  };
  popup.querySelector('[data-db-campaign-close]')?.addEventListener('click', close);
  document.addEventListener('focusin', () => {
    if (shown && hasBlockingSurface()) { popup.hidden = true; surfaceObserver?.disconnect(); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && shown && !hasBlockingSurface()) close(); });
  matchMedia('(min-width: 990px)').addEventListener('change', event => { if (!event.matches) popup.hidden = true; });
  window.addEventListener('storage', event => {
    if (event.key === `${key}:closedUntil` && Number(event.newValue || 0) > Date.now()) { popup.hidden = true; clearInterval(interval); }
  });
  interval = window.setInterval(tryShow, 1000);
  tryShow();
})();
